import { CallTaskTool } from "@repo/app-types/entities/callTaskEvent";
import type { CustomerInteractionAgentStep } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { Tool } from "@repo/app-types/entities/tool";
import { IconBan } from "@tabler/icons-react";
import type { FC } from "react";
import { AgentStepToolCallBlock } from "./gradingTranscriptToolActivityBlock.js";

const refusedToolLabel: Record<CallTaskTool, string> = {
  [CallTaskTool.SendText]: "Text not sent",
  [CallTaskTool.PlaceCall]: "Call not placed",
  [CallTaskTool.Wait]: "Wait not scheduled",
  [CallTaskTool.Finish]: "Task not finished",
};

interface GradingTranscriptAgentStepProps {
  step: CustomerInteractionAgentStep;
  tools: readonly Tool[] | undefined;
}

export const GradingTranscriptAgentStep: FC<GradingTranscriptAgentStepProps> = (
  props,
) => {
  const { step, tools } = props;
  if (step.type === "tool_called") {
    return <AgentStepToolCallBlock step={step} tools={tools} />;
  }

  // `refused` is written for the agent's next turn, so the agent's reason is shown instead.
  const label = step.tool ? refusedToolLabel[step.tool] : "No action taken";
  return (
    <div className="flex min-w-0 items-center space-x-2 text-gray-600">
      <IconBan aria-hidden="true" className="size-4 shrink-0" />
      <span className="min-w-0 wrap-anywhere">
        {step.reason ? `${label}: ${step.reason}` : label}
      </span>
    </div>
  );
};
